import React from 'react';

import AuthCheck from '@/components/AuthCheck';
import { NotFound } from '@/components/Error';
import ForgotPasswordContainer from '@/features/passwordManagement/components/ForgotPasswordContainer';
import ResetPasswordFormContainer from '@/features/passwordManagement/components/ResetPasswordFormContainer';

let routes = [
  {
    path: '/',
    element: <AuthCheck />
  },
  {
    path: '/reset-password/:token?',
    element: <ResetPasswordFormContainer />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordContainer />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
